import clsx from 'clsx'
import React, {useEffect} from 'react'
import {connect} from 'react-redux'
import {size, toArray} from 'lodash'
import {makeStyles} from 'external/material'

import {uploadFile, retryUpload, deleteUpload, resetUploads} from 'uploads/redux/actions'
import UploadItem from 'uploads/UploadItem'
import store from 'uploads/redux/store'

const useStyles = makeStyles(createStyles)

const UploadProgress = props => {
  const { fileProgress, uploadFile, retryUpload, deleteUpload, resetUploads, translate = a => a, downloadServer } = props
  const uploadedFileAmount = size(fileProgress)
  const classes = useStyles() 

  useEffect(() => {
    const fileToUpload = toArray(fileProgress).filter(file => file.progress === 0)
    uploadFile(fileToUpload)
  }, [uploadedFileAmount])

  return uploadedFileAmount > 0 ? (
    <div className={clsx(classes.wrapper)}>      
      {size(fileProgress)
        ? toArray(fileProgress).filter(f => !f.deleted)
          .map(file => { return (   
            <UploadItem
              key={file.id}
              file={file}
              retryUpload={() => retryUpload(file.id)}
              deleteUpload={() => deleteUpload(file.id)}
              downloadServer={downloadServer}
            />
          )})
        : null}
    </div>
  ) : null
}

const mapStateToProps = state => ({
  fileProgress: state.UploadFile.fileProgress,
})

const mapDispatchToProps = dispatch => ({
  uploadFile: files => dispatch(uploadFile(files)),
  retryUpload: id => dispatch(retryUpload(id)),
  deleteUpload: id => dispatch(deleteUpload(id)),
  resetUploads: () => dispatch(resetUploads())
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadProgress)


function createStyles(theme) {  
  return {
    wrapper: {
      padding: 5,
      marginTop: 10,
      backgroundColor: '#f7f5f7'
      
    }
  }
}
